import { Subscription } from "../../../../contracts/nexar-api/types";
import { TFunction } from "react-i18next";
import { convertDate } from "../../../../core/utils/date.utils";

export default function logicToRenderText(
  item: string,
  subscriptions: Subscription[] | null,
  t: TFunction
): string {
  if (!subscriptions) return "";
  const subscription = subscriptions.find(
    (subscription) => !!subscription.serialNumbers?.find((d) => d === item)
  );
  if (!subscription) return "";

  const startDate = subscription.startDate;

  if (subscription.status === "ACTIVE") {
    if (startDate && startDate < new Date()) {
      return t("pricePerMonth", { price: "$9.99" });
    } else {
      const isPrepaid = !!subscription.isPrepaid;
      if (isPrepaid) {
        return t("prepaidSubscriptionPeriodEndsOn", {
          date: convertDate(subscription.startDate),
        });
      } else {
        return t("freeTrialPeriodEndsOn", {
          date: convertDate(subscription.startDate),
        });
      }
    }
  }

  return "";
}
